module.exports = __webpack_public_path__ + "static/media/socials-linkedin-color.c0c43b6b.svg";